// import { ImageLoaderCSSStyleImpl, ImageLoaderCSSStyle } from '../../../../../toolkit/imageloader/imageloadercss';
import { MyTonesCardCSSStyle } from './mytonescardcss';
import { MyTonesCardComponentState, MyTonesCardComponentProps, MyTonesCardComponentHandler } from './mytonescardcomponent';
import * as React from 'react';
import { UIComponentViewImpl } from '../../../../../toolkit/uicomponentview';
import { UIDataModel, UIComponentHandler } from '../../../../../toolkit/uicomponent';
import { BaseContext } from '../../../../../../utils/basecontext';
import { PlayerComponent } from '../../../../../toolkit/player/playercomponent';
import { PlayerComponentCSSStyle } from '../../../../../toolkit/player/playercss';
import { MyToneCardPlayerCSSStyleImpl } from './mytonecardplayercss';
import { RepeatDaysDto, RepeatDaysDtoImpl } from '../../../../../../core/dto/repeatdaysdto/repeatdaysdto';
import { RepeatCardComponent } from '../repeatcard/repeatcardcomponent';
import { ImageLoaderComponent } from '../../../../../toolkit/imageloader/imageloadercomponent';
import { ImageLoaderCSSStyle } from '../../../../../toolkit/imageloader/imageloadercss';
import { MyTonesCardImageLoaderCSSStyleImpl } from './mytonescardimageloader';
import { Strings } from '../../../../../../utils/resources/strings';
// import './mytones-card-style.css';
import { MyTonesEvenCardImageLoaderCSSStyleImpl } from './mytonesevencardimageloader';
import { RepeatCardCSSStyleImpl } from '../repeatcard/repeatcardcss';
// import { RepeatLabelCSSStyleImpl } from '../repeatcard/repeatlabelcss';
import { PopUpWrapperComponent } from '../../../../popup/popupwrappercomponent';
import { DeleteConfirmComponent } from '../../../../popup/deleteconfirmation/deleteconfirmationcomponent';
import { RepeatLabelCSSStyleImpl } from '../repeatcard/repeatlabelcss';
import { LanguageConst } from 'src/com/sixdee/crbtportal/utils/resources/languageconst';

export class MyTonesCardViewImpl extends UIComponentViewImpl<UIDataModel> 
{
    
    // private imageLoaderCSSStyle: ImageLoaderCSSStyle;
    private popUpComponent:PopUpWrapperComponent;
    private imageLoaderCSSStyle: ImageLoaderCSSStyle;
    private evenImageLoaderCSSStyle:ImageLoaderCSSStyle;

    private playerComponent: PlayerComponent | null;
    private initialStateOfTonePlaying: boolean;
    private playerCSSStyle: PlayerComponentCSSStyle;

    constructor(context: BaseContext, handler: UIComponentHandler)
    {
        super(context, handler);
        this.imageLoaderCSSStyle = new MyTonesCardImageLoaderCSSStyleImpl(context);
        this.evenImageLoaderCSSStyle = new MyTonesEvenCardImageLoaderCSSStyleImpl(context);

        // this.myToneCardCSSStyle =  context.getUserContext().getLanguage() === LanguageConst.FRENCH ? 
        // new MyTonesCardCSSStyleImpl(context) : new ArabicMyTonesCardCSSStyleImpl(context);

        
        // this.imageLoaderCSSStyle = new ImageLoaderCSSStyleImpl(context);

        this.playerCSSStyle = new MyToneCardPlayerCSSStyleImpl(context);
    }

    bindHandlers()
    {
       this.onDeleteClicked = this.onDeleteClicked.bind(this);
       this.onPlayClicked = this.onPlayClicked.bind(this);
       this.onStopClicked = this.onStopClicked.bind(this);
       this.onDeleteConfirmed= this.onDeleteConfirmed.bind(this);
       this.closePopup = this.closePopup.bind(this);
    }

    draw(props: MyTonesCardComponentProps, state: MyTonesCardComponentState, cssStyle: MyTonesCardCSSStyle): JSX.Element | boolean
    {
        super.draw(props, state, cssStyle);
        console.log("Get Caller ?????? :",this.getDefaultTuneStatus(props)+"Tune Name:",props.playingMyTunesdto.getToneName());
        let repeactCardCSS = props.playingMyTunesdto.getType() === this.getUIProps().context.getResources().getString(Strings.WEEKLY)
        ? new RepeatCardCSSStyleImpl(this.getContext()) : new RepeatLabelCSSStyleImpl(this.getContext());
        return (
            <div key={props.position} className="swiper-slide">
              <div style={props.cssStyle.getWrapperCSSStyle()}>

                       <div style={props.cssStyle.getRoundProfileImageDivCSSStyle()}>
                            {/* <img  style={{borderRadius:'8px',}}src={props.playingMyTunesdto.getImgPath()} width="98%" height="99%"/> */}
                            {props.position % 2 === 0 ?  <ImageLoaderComponent defaultImageName={"default_image.jpg"} imagePath={props.playingMyTunesdto.getImgPath()} imageLoaderCSSStyle={this.imageLoaderCSSStyle} context={props.context}/>:<ImageLoaderComponent defaultImageName={"default_image.jpg"} imagePath={props.playingMyTunesdto.getImgPath()} imageLoaderCSSStyle={this.evenImageLoaderCSSStyle} context={props.context}/>}
                          {
                              this.getDefaultTuneStatus(props) === true ?
                               <div id="default-tag-div" style={cssStyle.getDefaultStatusCSSStyle()}>
                                    <img  style={{zIndex:1000,position:"relative",transform:this.getContext().getUserContext().getLanguage() === LanguageConst.ARABIC ?"rotate(180deg)":""}} src={props.context.getResources().getImage("default_tune.svg")} width="128px" height="100%"/>
                                    <div style={cssStyle.getDefaultLabelCSSStyle()}>
                                    {props.context.getResources().getString(Strings.default)}

                                    </div>
                               </div>   :
                               <span/> 
                          }
                           
                       </div>   
                     
                

                   <div style={props.cssStyle.getToneDivCSSStyle()}>
                           <div style={{width:'60%',height:'100%',textAlign:this.getContext().getUserContext().getLanguage() === LanguageConst.FRENCH?"left":"right",marginRight:this.getContext().getUserContext().getLanguage() === LanguageConst.FRENCH?"0px":"10px"}}>
                                <div style={props.cssStyle.getToneNameLabelCSSStyle()}>
                                        {props.playingMyTunesdto.getToneName()}
                                </div>
                                <div style={props.cssStyle.getArtistNameLabelCSSStyle()}>
                                        {props.playingMyTunesdto.getArtistName()}
                                </div>
                           </div>
                           <div style={{width:'40%',height:'100%',display:"flex"}}>
                                <PlayerComponent playIconName={"play.svg"} pauseIconName={"pause.svg"} playerCSSStyle={this.playerCSSStyle} isPlaying={this.initialStateOfTonePlaying} onPlayClicked={this.onPlayClicked} onStopClicked={this.onStopClicked} ref={item=>this.playerComponent=item} context={this.getUIProps().context}/>
                                <div onClick={()=>this.onDeleteConfirmed()} style={props.cssStyle.getDeleteButtonCSSStyle()}>
                                            <img width='30px' height='30px' src={this.getContext().getResources().getImage("delete_trash.svg")}/>
                                </div>   
                           </div>
                          
                       </div> 
                      
                   <div style={props.cssStyle.getBarDivCSSStyle()} />   
                                          
                   <div style={props.cssStyle.getRowHeaderDivCSSStyle()}>
                         <label style={props.cssStyle.getRowLabel1CSSStyle()}>
                             {this.getContext().getResources().getString(Strings.status)}
                         </label>
                         <label style={props.cssStyle.getRowLabel2CSSStyle()}>
                             {this.getContext().getResources().getString(Strings.callers)}
                         </label>
                         <label style={props.cssStyle.getRowLabel3CSSStyle()}>
                             {this.getContext().getResources().getString(Strings.time)}
                         </label>
                      </div>
                      <div style={props.cssStyle.getRowContentDivCSSStyle()}>
                         <label style={props.cssStyle.getRowLabel1CSSStyle()}>
                             {props.playingMyTunesdto.getCallerStatus()}
                         </label>
                         <label style={props.cssStyle.getRowLabel2CSSStyle()}>
                             {props.playingMyTunesdto.getCaller()}
                         </label>
                         <label style={props.cssStyle.getRowLabel3CSSStyle()}>

                             {
                              this.getTimeType(props.playingMyTunesdto.getTime())
                             }
                         </label>
                      </div>
                      <div style={props.cssStyle.getBarDivCSSStyle()}/>

                      <div style={props.cssStyle.getRowHeaderDivCSSStyle()}>
                         <label style={props.cssStyle.getFromDateLabelCSSStyle()}>
                             {this.getContext().getResources().getString(Strings.from)}
                         </label>
                        
                         <label style={props.cssStyle.getToDateLabelCSSStyle()}>
                             {this.getContext().getResources().getString(Strings.to)}
                         </label>
                      </div>
                      <div style={props.cssStyle.getRowContentDivCSSStyle()}>
                         <label style={props.cssStyle.getFromDateLabelCSSStyle()}>
                             {props.playingMyTunesdto.getFrom()}
                         </label>
                        
                         <label style={props.cssStyle.getToDateLabelCSSStyle()}>
                             {props.playingMyTunesdto.getTo()}
                         </label>
                      </div>
                      <div style={props.cssStyle.getBarDivCSSStyle()}/>
                       <div style={props.cssStyle.getRowHeaderDivCSSStyle()}>
                           <label style={props.cssStyle.getRepeatLabelCSSStyle()}>
                               {this.getContext().getResources().getString(Strings.repeat)}
                           </label>
                       </div>
                       <div style={props.cssStyle.getRepeatDivCSSStyle()}>

                         {
                            this.getRepeatingDayView(props.playingMyTunesdto.getRepeats()).map((dto:RepeatDaysDto)=>
                            {   
                               return<>
                               <RepeatCardComponent cssStyle={repeactCardCSS}  title={dto.getTitle()} isSelected={dto.getIsSelected()} context={props.context}/>
                                     
            
                               </>;
                            })
                    
                         }
                            <PopUpWrapperComponent ref={(item: any) => this.popUpComponent = item} context={props.context}/>
                         
                        </div>      
                </div>  
             
           </div>   
                         
        );
    }
   

    getTimeType(time:string):string{
        if(time === this.getContext().getResources().getString(Strings.full_day))
        {
            return "24/7";

        }
        return time;

    }
    getDefaultTuneStatus(props:MyTonesCardComponentProps):boolean{
        console.log("getDefaultTuneStatus() invoked:",props.playingMyTunesdto.getCaller()+"time Type:",props.playingMyTunesdto.getRepeats().length+"Weekly Days:",props.playingMyTunesdto.getTime());
        if((props.playingMyTunesdto.getCaller() === this.getContext().getResources().getString(Strings.all) && props.playingMyTunesdto.getTime() === this.getContext().getResources().getString(Strings.full_day) && (props.playingMyTunesdto.getRepeats().length === 0)) === true)
        {       
           return true;
        }
        else
        {
            return  false;
        }
        // if(props.playingMyTunesdto.getCaller() === this.getContext().getResources().getString(Strings.all_callers) && props.playingMyTunesdto.getType())
    }
    getRepeatingDayView(repeatingList:string[]):RepeatDaysDto[]
    {
        console.log("------repeatlist: " + repeatingList);
        let type = (this.getUIProps() as MyTonesCardComponentProps).playingMyTunesdto.getType();
        let days: RepeatDaysDto[];

        console.log("-----type: " + type);
        if(type === this.getUIProps().context.getResources().getString(Strings.WEEKLY))
        {
            days = this.getRepeatDayName();
        }
        else 
        {
            // days = this.getRepeatDayName();

            days = this.getRepeatMode();
        }

        days.forEach((jsonData: RepeatDaysDtoImpl) =>
        {
            if(repeatingList.includes(jsonData.getTitle()))
            {
                jsonData.setIsSelected(true);
            }
        });

        console.log("------days: " + JSON.stringify(days));
       return days; 
    }    
    
           
    getRepeatDayName():RepeatDaysDto[]
    { 
        let days: RepeatDaysDto[] = [];

        let sun:RepeatDaysDtoImpl;
        sun = new RepeatDaysDtoImpl();
        sun.setTitle(this.getContext().getResources().getString(Strings.sun));
        sun.setIsSelected(false);
        days.push(sun);


        let mon:RepeatDaysDtoImpl;
        mon = new RepeatDaysDtoImpl();
        mon.setTitle(this.getContext().getResources().getString(Strings.mon));
        mon.setIsSelected(false);
        days.push(mon);


        let tue:RepeatDaysDtoImpl;
        tue = new RepeatDaysDtoImpl();
        tue.setTitle(this.getContext().getResources().getString(Strings.tue));
        tue.setIsSelected(false);
        days.push(tue);


        let wed:RepeatDaysDtoImpl;
        wed = new RepeatDaysDtoImpl();
        wed.setTitle(this.getContext().getResources().getString(Strings.wed));
        wed.setIsSelected(false);
        days.push(wed);

          
        let thur:RepeatDaysDtoImpl;
        thur = new RepeatDaysDtoImpl();
        thur.setTitle(this.getContext().getResources().getString(Strings.thu));
        thur.setIsSelected(false);
        days.push(thur);


        let fri:RepeatDaysDtoImpl;
        fri = new RepeatDaysDtoImpl();
        fri.setTitle(this.getContext().getResources().getString(Strings.fri));
        fri.setIsSelected(false);
        days.push(fri);


        let sat:RepeatDaysDtoImpl;
        sat = new RepeatDaysDtoImpl();
        sat.setTitle(this.getContext().getResources().getString(Strings.sat));
        sat.setIsSelected(false);
        days.push(sat);


        console.log("%%%%%%%%%%%%%%%",days.toString());
        return days;
        
        
    }

    getRepeatMode():RepeatDaysDto[]
    { 
        let days: RepeatDaysDto[] = [];

        let sun:RepeatDaysDtoImpl;
        sun = new RepeatDaysDtoImpl();
        sun.setTitle(this.getContext().getResources().getString(Strings.none));
        sun.setIsSelected(false);
        days.push(sun);

        let tue:RepeatDaysDtoImpl;
        tue = new RepeatDaysDtoImpl();
        tue.setTitle(this.getContext().getResources().getString(Strings.monthly));
        tue.setIsSelected(false);
        days.push(tue);

        let mon:RepeatDaysDtoImpl;
        mon = new RepeatDaysDtoImpl();
        mon.setTitle(this.getContext().getResources().getString(Strings.yearly));
        mon.setIsSelected(false);
        days.push(mon);

        return days;
    }

    onPlayComplete(): void 
    {
        this.initialStateOfTonePlaying = false;
        this.playerComponent !== null && this.playerComponent.onPlayComplete();
    }
   
    onPlayStop(): void 
    {
        this.initialStateOfTonePlaying = false;
        this.playerComponent !== null && this.playerComponent.onPlayStop();
    }

    onDeleteClicked(id:string)
    {
        this.popUpComponent !== null && this.popUpComponent.setShowWindow(true, 
        <DeleteConfirmComponent msg={this.getContext().getResources().getString(Strings.you_are_about_to_delete_the_tune_settings_your_callers_will_no_longer_hear_it)} id={id}  headerTitle={"Confirm"} closePopup={this.closePopup} context={this.getContext()} onConfirmClick={this.onDeleteConfirmed} onCancelClick={this.closePopup} />);
    }

    onDeleteConfirmed()
    {
      
        (this.getUIComponentHandler() as MyTonesCardComponentHandler).onDeleteClicked();

    }

   
    protected closePopup()
    {
        this.popUpComponent !== null && this.popUpComponent.setShowWindow(false, <></>);
    }
    private onPlayClicked(): void
    {
        this.initialStateOfTonePlaying = true;
        this.getContext().getPlayerManager()
                    .startPlay((this.getUIProps() as MyTonesCardComponentProps).playingMyTunesdto.getToneUrl(), this);
    }

    private onStopClicked(): void
    {
        this.initialStateOfTonePlaying = false;

        this.getContext().getPlayerManager().stopPlay();
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/listtone/viewmodel/mytonescard/mytonescardview.tsx